import React from 'react';
import logo from "./Images/special sales triple stand pendant necklace(1).png"

const Header = () => {
    return <>
        <div className='header'>
            <img src={logo} alt="Logo" />
        </div>
    </>;
}

export default Header;